import { HomologationSemesterCourse } from '../../../types';

interface Props {
  semesterCourse: HomologationSemesterCourse;
}

function getCourseBoxStyle(sc: HomologationSemesterCourse) {
  if (!sc.isSelected) {
    return {};
  }

  const status = sc.courseResult?.status;
  if (status === 'approved') {
    return {
      border: '1px solid #4caf50',
      backgroundColor: 'rgba(76, 175, 80, 0.08)',
    };
  }
  if (status === 'rejected') {
    return {
      border: '1px solid #f44336',
      backgroundColor: 'rgba(244, 67, 54, 0.08)',
    };
  }
  return {
    border: '1px solid #1976d2',
    backgroundColor: 'rgba(25, 118, 210, 0.08)',
  };
}

export default function CourseCard({ semesterCourse }: Props) {
  const { course } = semesterCourse;

  return (
    <div
      className="course-box"
      style={{
        ...getCourseBoxStyle(semesterCourse),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        maxWidth: '100%',
        width: '100%',
        minHeight: '145px',
      }}
    >
      <span className="name">{course.name}</span>
      <div className="course-box__info">
        {course.code && <span>Código: {course.code}</span>}
        <span>Créditos: {course.credits}</span>
        {semesterCourse.courseType && (
          <span className="type">{semesterCourse.courseType.name}</span>
        )}
      </div>
    </div>
  );
}
